var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9044 25.3886L9.19971 30.0933L10.6139 31.5075L16.7328 25.3886H16.7377L18.5395 23.5868C18.5385 23.5861 18.5376 23.5854 18.5367 23.5847L26.1166 16.0048V16.0097L28.1166 14.0097V14.0048L33.2077 8.91371L31.7935 7.4995L28.1079 11.1851C27.9244 8.69977 24.8863 7.48383 23.0379 9.26002L17.4574 14.6226H13.0838C11.427 14.6226 10.0838 15.9657 10.0838 17.6225V22.3886C10.0838 24.0454 11.427 25.3886 13.0838 25.3886H13.9044ZM15.9044 23.3886L26.1166 13.1764V11.4232C26.1166 10.5418 25.0592 10.0914 24.4237 10.7021L18.5529 16.3436C18.3667 16.5226 18.1184 16.6226 17.86 16.6226H13.0838C12.5316 16.6226 12.0838 17.0703 12.0838 17.6225V22.3886C12.0838 22.9409 12.5316 23.3886 13.0838 23.3886H15.9044ZM18.5658 26.3889L19.9802 24.9745L24.4198 29.2874C25.0538 29.9033 26.1166 29.4541 26.1166 28.5702V18.8381L28.1166 16.8381V28.5702C28.1166 31.222 24.9282 32.5697 23.0262 30.722L18.5658 26.3889Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.4d3a25b65008ee96e2c613b75d30af76.svg";
export { ForwardRef as ReactComponent };